module.exports = __webpack_public_path__ + "static/media/bannerbgindividual.79269026.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bannerbgindividual.png
// module id = 663
// module chunks = 0